import React from "react";
//material ui
import makeStyles from "@material-ui/styles/makeStyles";
import Paper from "@material-ui/core/Paper";
//jazasoft
import { PageHeader, SimpleForm, required, translate as translateHOC } from "jazasoft";

// local
import ExcelErrorDialog from "../../components/ExcelErrorDialog";
import MyFileInput from "../../components/MyFileInput";
import useUser from "./useUser";

const useStyles = makeStyles(_ => ({
  root: {
    margin: "1.5em",
    padding: "1.5em"
  }
}));

const UserUpload = props => {
  const { translate } = props;
  const { errorList, setErrorList, onUpload } = useUser(props);

  const classes = useStyles();
  return (
    <div>
      <PageHeader title={translate("resources.users.page.upload")} />

      <ExcelErrorDialog
        maxWidth="xl"
        open={errorList?.length > 0 || false}
        errors={errorList}
        onClose={() => setErrorList(null)}
      />

      <Paper className={classes.root}>
        <SimpleForm onSubmit={onUpload}>
          <MyFileInput
            source="file"
            label={translate("resources.users.title.excel_file", { _: "Excel file" })}
            // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            accept={{
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
              "application/vnd.ms-excel": [".xls"]
            }}
            message={translate("js.message.drop_file", { _: "Drag and drop file here, or click to select file" })}
            xs={12}
            fullWidth
            validate={required()}
          />
        </SimpleForm>
      </Paper>
    </div>
  );
};

export default translateHOC(UserUpload);
